<script lang="ts">
  import IconButton from "$components/+design-system/IconButton/IconButton.svelte";
  import Separator from "$components/+shared/Separator/Separator.svelte";
  import { hasDefault, sidePanel } from "$stores/sidePanel";
  import { Cross, Left } from "$components/+shared/OVIcon";
</script>

{#if $$slots.title}
  <div
    class="grid h-[48px] shrink-0 grid-cols-[minmax(min-content,_1fr)_minmax(max-content,_1fr)_minmax(0,_1fr)] items-center gap-3 overflow-hidden px-3"
  >
    <span class="col-start-1">
      <slot name="actionButton">
        <!-- this shows the back/close button if the slot is empty -->
        <IconButton
          variant="tertiary"
          icon={$hasDefault ? Left : Cross}
          a11yLabel={$hasDefault ? "Go back" : "Close"}
          on:click={sidePanel.clearPanel}
        />
      </slot>
    </span>
    <span class="col-start-2 justify-self-center">
      <slot name="title" />
    </span>
  </div>
  <Separator />
{/if}

<slot name="content" />
